// extracted by mini-css-extract-plugin
export default {"anchor_to_credit":"ModalInfo_anchor_to_credit__VVNpS","stats_icon":"ModalInfo_stats_icon__ErGKR"};